
import { defineComponent } from 'vue'
import { iInputVariable } from '../../FunctionsCatalog'
import { formatDate } from '@/helpers/commons/localeHelper'
import Calendar from 'primevue/calendar'
import Dropdown from 'primevue/dropdown'
import functionsCatalogInputTabDescriptor from './FunctionsCatalogInputTabDescriptor.json'

export default defineComponent({
    name: 'function-catalog-input-column',
    components: { Calendar, Dropdown },
    props: { variable: { type: Object }, readonly: { type: Boolean } },
    emits: ['deleted'],
    data() {
        return {
            functionsCatalogInputTabDescriptor,
            inputVariable: {} as iInputVariable
        }
    },
    watch: {
        variable() {
            this.loadVariable()
        }
    },
    created() {
        this.loadVariable()
    },
    methods: {
        loadVariable() {
            this.inputVariable = this.variable as iInputVariable
            if (this.inputVariable.type === 'DATE') {
                this.inputVariable.value = this.getFormatedDate(this.inputVariable.value)
            }
        },
        onTypeChange() {
            this.inputVariable.value = ''
        },
        deleteVariableConfirm() {
            this.$confirm.require({
                message: this.$t('common.toast.deleteMessage'),
                header: this.$t('common.toast.deleteTitle'),
                icon: 'pi pi-exclamation-triangle',
                accept: () => this.$emit('deleted')
            })
        },
        getFormatedDate(date: any) {
            return formatDate(date, 'MM/DD/YYYY')
        }
    }
})
